export const US_PHONE_COUNTRY_CODE = "+1";
export const US_PHONE_FORMAT = "XXX-XXX-XXXX";
